import Tag from './web/Tag';
import TagInformative from './web/Informative';
Tag.Informative = TagInformative;
export default Tag;